<!-- 底部bar -->
<template>
  <div class="bottom-bar">
    <div class="repair-left">
      <div class="repair-left-price">
        <div class="estimated-price-title os-font-12-500">预估维修费</div>
        <div
          class="estimated-price-price os-font-18-500"
          v-if="componentPriceData.totalPrice && componentPriceData.totalPrice > 0"
        >
          <div class="estimated-price-symbol os-font-12-500">￥</div>
          <div class="estimated-price-text os-font-18-500">
            {{ componentPriceData.totalPrice | formatMoney }}
          </div>
          <div @click="showPricePopup" class="estimated-price-icon"></div>
        </div>
        <div class="estimated-price-title os-font-12-500" v-else-if="selectedProblemList.id">
          &nbsp;待检测评估
        </div>
        <div class="estimated-price-title os-font-12-500" v-else>&nbsp;--</div>
      </div>
      <div class="repair-left-tips os-font-12-400">
        <span>*</span>最终费用以服务中心检测和沟通为准
      </div>
    </div>
    <div
      :class="{
        disabled: holidayIsValid || !this.selectedModel.id || !this.selectedProblemList.id
      }"
      class="repair-right os-font-16-400"
      @click="goNext"
    >
      <div class="button-next">
        下一步
        <div class="next-step">(1/2)</div>
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/utils/toast'
import { mapState } from 'vuex'

export default {
  name: 'bottomBar',
  data() {
    return {}
  },
  computed: {
    ...mapState('repair', [
      'componentPriceData',
      'baseNextCheck',
      'holidayIsValid',
      'selectedProblemList',
      'selectedModel'
    ])
  },
  methods: {
    goNext() {
      if (this.holidayIsValid) {
        return
      }

      if (!this.selectedModel.id) {
        toast('请选择型号')
        return
      }

      if (!this.selectedProblemList.id) {
        toast('请选择故障')
        return
      }

      if (this.baseNextCheck) {
        this.$emit('goNext')
      }
    },
    showPricePopup() {
      this.$emit('showPricePopup')
    }
  }
}
</script>

<style lang="scss" src="./index.scss" scoped></style>
